import{css}from'glamor';var amount=css({textAlign:'right',order:4}).toString();export default{amount:amount};